// Widget Scripts
import mainSlideshow from './js/widgets/mainSlideshow.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cards from './js/widgets/cards.js';
import seo from './js/widgets/seo.js';
import sponsors from './js/widgets/sponsors.js';
import sponsorsManaged from './js/widgets/sponsorsManaged.js';
import gallery from './js/widgets/gallery.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    mainSlideshow();
    multiScheduleFeature();
    cards();
    seo();
    sponsors();
    sponsorsManaged();
    gallery();
  });
}
